export const OUTPUT_DATE_FORMAT = 'MMM D, YYYY';
export const TRACE_TABLE_MATURITY_DATE_FORMAT = 'LLL d, yyyy';
export const TRACE_TABLE_TRADE_FORMAT = 'LLL d, yyyy HH:mm:ss';

export enum Periods {
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}

export enum PageTitles {
  Articles = 'Commentary & Deal Flow',
  Stats = 'Stats',
}
